import { Fragment, FC } from "react";
import { Route, Switch } from "react-router-dom";
import Login from "./Login";
import Create from "./Create";
import AddRole from "./AddRole";
import SendEmail from "./SendEmail";
import { Guard } from "../Guard";

import { GuardedRoute } from "../GuardedRoute";

import { Loading } from "../../pages/Loading";

import { Forbidden } from "../../pages/Forbidden";

interface Props {
    tenant: string;
}

const UserRouter: FC<Props> = ({ tenant }) => {

    const apps = [
        {
            name: "create",
            url: "/user/create",
            component: Create,
        },
        {
            name: "addRole",
            url: "/user/addRole/:userId",
            component: AddRole,
        },
        {
            name: "sendEmail",
            url: "/user/sendEmail/:userId",
            component: SendEmail,
        }
    ];

    return (
        <Fragment>
            <Guard loadingComponent={Loading}>
                <Switch>
                        {apps.map((app) => (
                            <GuardedRoute
                                key={app.name}
                                path={app.url}
                                component={app.component}
                                forbiddenUrl="/forbidden"
                            />
                        ))}
                        <Route exact path="/user">
                            <Login tenant={tenant}/>
                        </Route>
                        <Route path="/forbidden" component={Forbidden} />
                    </Switch>
            </Guard>
        </Fragment>
    );
};

export default UserRouter;
